// extracted by mini-css-extract-plugin
export default {"root":"legal-entity-page__pages__plan-list-template-page__right__root"};